import { Button } from 'antd'

import { useCertificationsStore } from '../Store/hooks/useStore'

import { CertificationCreateButtonProps } from './interface'

export const CertificationCreateButton = ({
  disabled
}: CertificationCreateButtonProps) => {
  const toggleCertificationFormVisible = useCertificationsStore(
    state => state.toggleCertificationFormVisible
  )

  return disabled ? null : (
    <Button
      style={{ marginBottom: 14, width: '64px' }}
      type='default'
      onClick={toggleCertificationFormVisible}
    >
      添加
    </Button>
  )
}
